import { useEffect, useMemo, useState } from 'react'
import './Home.less'
import useHistory from '@/hooks/useHistory'
import Tabs from '@/components/Tabs'
import Information from '@/components/List/Information'
import { _getDataMap, _getCanGetGift, _submitAuthSuccess, _getIsNeedAuth } from '@/api/user'
import { Toast } from 'dingtalk-design-mobile'
// import dd from '@/utils/dd.config'
// import { getENV, } from 'dingtalk-jsapi/lib/env';
// import { compareVersion, } from 'dingtalk-jsapi/lib/sdk/sdkLib';
import { openAuth } from 'dingtalk-design-libs/biz/openAuth';
import { getCorpId } from '@/utils/tool'
import dd from '@/utils/dd.config'
import { _authAlipay } from '../../api/user'

const tabs = [{
  name: '组织建设',
  img: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab1.png',
  path: 'OrganizationBuild'
}, {
  name: '维权服务',
  img: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab2.png',
  path: 'RightsService'
}, {
  name: '职工服务',
  img: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab3.png',
  path: 'WorkerService'
}, {
  name: '全部服务',
  img: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab4.png',
  path: ''
}]

const informs = [
  // {path: 'ActivityList', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab5.png'},
  {path: 'InternetSchool', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab13.png'},
  // {path: 'WorkerMien', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab9.png'},
  {path: 'CulturePalace', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab10.png'},
  {path: 'PsychiatristBrief', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab11.png'},
  {path: 'AdviceForm', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab12.png'},
]

const tabShow = [
  { path: 'WorkerMien', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab15.png' },
  { path: 'BeautifulWorker', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab14.png' },
  { path: 'BeautifulBuilder', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab17.png' },
  { path: 'InnovationWorkshop', url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/tab16.png' },
]

// const avatars = [
//   'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/avatar1.png',
//   'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/avatar2.png',
//   'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/avatar3.png',
//   'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/avatar4.png',
//   'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/avatar5.png',
//   'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/avatar6.png'
// ]

const footerTabs = [{
  title: '工会政策',
  key: 1
}, {
  title: '新闻动态',
  key: 2
}, {
  title: '工作动态',
  key: 3
}]

const informationDate = [
  [{
    title: "关于实施小额缴费工会组织工会经费全额返还",
    date: "2023-06-01",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/home-inform.png",
    id: 1
  }, {
    title: "中工总字[2018]6号 关于转发《中华全国总工会办公厅关于印发《基层工会经费收支管理办法》的通知》的通知",
    date: "2018-02-05",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/home-inform.png",
    id: 2
  }],
  [{
    title: "总书记这样指导工运事业和工会工作",
    date: "2023-10-29",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/new1.png",
    url: 'https://mp.weixin.qq.com/s/2kz4IqXSkuS0fKDmKIansw',
    id: 3
  }, {
    title: "面对面心贴心 习近平与工人在一起",
    date: "2023-10-29",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/new2.png",
    url: 'https://mp.weixin.qq.com/s/TWIWNWnt0a3TP3SziqQ4mw',
    id: 4
  }, {
    title: "三次同全总新班子谈话 这个主题始终如一",
    date: "2023-10-29",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/new3.png",
    url: 'https://mp.weixin.qq.com/s/VUmEWmUufatRRQ43jf7gjw',
    id: 5
  }, {
    title: "习近平：坚持党对工会的全面领导 组织动员亿万职工积极投身强国建设民族复兴伟业",
    date: "2023-10-24",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/new4.png",
    url: 'https://mp.weixin.qq.com/s/9YD2RgoU_FtHAKel7zYSKA',
    id: 6
  }],
  [{
    title: "擦亮“工”字品牌！市总工会到东区街道指导",
    date: "2023-10-30",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/work1.png",
    url: 'https://mp.weixin.qq.com/s/QQVSALS_ThqzvgICPcckWA',
    id: 7
  }, {
    title: "“美丽园区”点“靓”行动④丨以“咖”会友",
    date: "2023-10-21",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/work2.png",
    id: 8,
    pageUrl: '/ActivityDetail?id=03',
  }, {
    title: "如何维护好职工合法权益？ 这场专题培训划",
    date: "2023-10-18",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/work3.png",
    url: 'https://mp.weixin.qq.com/s/ZO_bAoZjsyRa7UcQhxL6kg',
    id: 9
  }, {
    title: "情暖中秋！东区街道总工会慰问困难职工",
    date: "2023-09-23",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/work4.png",
    url: 'https://mp.weixin.qq.com/s/fhcIYxqcDIV0Co4LuZrLDA',
    id: 10
  }, {
    title: '"庆国庆 展风采“东区街道总工会职工剪纸',
    date: "2023-09-25",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/work5.png",
    id: 11,
    pageUrl: '/ActivityDetail?id=04',
  }, {
    title: "东区街道总工会庆中秋活动",
    date: "2023-09-22",
    img: "http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/work6.png",
    id: 12,
    pageUrl: '/ActivityDetail?id=05',
  }]
]

const Home = () => {
  const history = useHistory()
  const [eyeMap, setEyeMap] = useState({})
  const [isShowGift, setIsShowGift] = useState(false)
  const isFLDD = useMemo(() => {
    const corpId = getCorpId() || ''
    return corpId === 'ding319dce7f51626987bc961a6cb783455b'
  }, [])

  // const { platform, version, appType, } = getENV();
  /**
   * 判断当前app版本是否支持使用SDK
   * @return {boolean}
   */
  // const isAuthSDKSupport = () => {
  //   return compareVersion(version, '6.3.35');
  // }

  useEffect(() => {
    // openDingAuth();    删除授权   因为已经授权过了
    getShowGift();
    // isAuthSDKSupport()
    getEyeList()
  }, [])

  const getShowGift = () => {
    _getCanGetGift().then(([success, res]) => setIsShowGift(success && res))
  }

  const openDingAuth = () => {
    _getIsNeedAuth().then(([success, res]) => {
      if (success && res) {
        openAuth({
          clientId:'suite8fkflv3pm9fbgsk6', // 应用ID(唯一标识)
          corpId: getCorpId() || 'dinged57bd8b6ba53cffbc961a6cb783455b', // 当前组织的corpId
          rpcScope:'qyapi_get_department_list,qyapi_get_department_member,qyapi_get_member',
          fieldScope:'Contact.User.mobile',
          type: 1 // 0 标识授权个人信息；1 标识授权组织信息
        }).then((res) => {
          if (res.status === 'ok')
            _submitAuthSuccess()
        })
      }
    })
  }

  const getEyeList = () => {
    _getDataMap({ type: 1 }).then(([success, res]) => {
      if (success) {
        setEyeMap(res)
      }
    })
  }


  const goPage = (path, id = null) => {
    if (!path) {
      Toast.info({
        content: "正在开发中，敬请期待！"
      })
      return
    }
    history.push(`/${path}${id ? '?id=0' + id : ''}`)
  }
  const toEle = () => {
    // dd.quit()
    window.location.replace('https://h5.ele.me/minisite/pages-gonghui/home/index?from=mobile.greenbuy&businessComeFrom=gonghuiding&corpId=ding0d6305c4d41f5d22f2c783f7214b6d69&dingClientId=suitewi4l9bmimgefvr3a&ebg_noH5Login=1')
  }

  const toTest = (val) => {
    const token = localStorage.getItem('TOKEN') || ''
    dd.openLink(`alipays://platformapi/startapp?appId=20000067&url=https%3A%2F%2Fopenauth.alipay.com%2Foauth2%2FpublicAppAuthorize.htm%3Fapp_id%3D2021004133635078%26scope%3Dauth_user%26redirect_uri%3Dhttps%3A%2F%2Fapp135177.eapps.dingtalkcloud.com%2Fworkweb%2Findex%3Ftoken%3D${token}`)
   
  }

  // const toTest2 = () => {
  //   alert(window.location.href)
  // }

  const gotoGift = () => {
    history.push('/GiftPack')
  }

  return <div className='home'>
    <div className='home-top-tabs'>
      <div className='tab-item' onClick={toEle}>惠生活</div>
      <div className='tab-item active'>惠工作</div>
      {
        isFLDD && <div className='tab-item' onClick={toTest}>测试</div>
      }
      
      {/* 跳转微信测试 */}
      {/* <a className='tab-item' href="weixin://dl/business/?t=XTSkBZlzqmn&cq=a%3Dhello">打开微信小程序</a> */}
    </div>
    <div className='home-header'>
      <div className='home-header-info'>
        <img alt='加载中' className='home-annunciate' src='http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/home-annunciate.png' />
        <div className='home-news'>
          <span>中山市工惠钉小程序正式运行啦！</span>
          {/* <span>更多</span> */}
        </div>
      </div>
      {isShowGift && <img
        className='home-gift'
        onClick={gotoGift}
        src='http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/home/gift.gif'
      />}
      {/* <div className='test' onClick={toTest}></div> */}
      {/* <div className='home-tabs'>
          {
          tabs.map(({ name, img, path }) => <div
            key={name}
            className='home-tab'
            onClick={() => goPage(path)}
          >
            <img alt='加载中' className='home-tab-img' src={img} />
            <div className='home-tab-text'>{ name }</div>
          </div>)
        }
      </div> */}
      <div className='home-informs'>
        {
          informs.map(item => <img alt='加载中' key={item.url} src={item.url} onClick={() => goPage(item.path)}/>)
        }
      </div>
    </div>
    <div className='home-labour'>
      风采展示
    </div>
    <div className='home-show'>
      {
        tabShow.map(item => <img src={item.url}  alt='加载中' key={item.url} onClick={() => goPage(item.path, '2')} />)
      }
    </div>
    {/* <div className='home-labour'>
      劳模风采
    </div>
    <div className='home-avatars'>
      {
        avatars.map((item, index) => <img
          className='home-avatar'
          key={item}
          src={item}
          alt="加载中"
          onClick={() => goPage('WorkerMienDetail', index + 11)}
        />)
      }
    </div> */}
    <div className='line'/>
    <div className='footer'>
      <Tabs tabs={footerTabs} >
        {
          informationDate.map((item, index) => {
            const key = footerTabs[index].key
            return <div key={key}>
              {
                item.map(inforItem => <Information
                  key={inforItem.id}
                  item={{ ...inforItem, eye: eyeMap[inforItem.id] || 0 }}
                  onClick={getEyeList}
                />)
              }
            </div>
          })
        }
      </Tabs>
    </div>
  </div>
}

export default Home
